/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-documents
 * crm-screener-documents
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import {
    type EnqueueGenerateReport200Response,
    EnqueueGenerateReport200ResponseFromJSON,
    EnqueueGenerateReport200ResponseToJSON,
} from '../models/EnqueueGenerateReport200Response';
import {
    type ScreenerGeneratedDocumentType,
    ScreenerGeneratedDocumentTypeFromJSON,
    ScreenerGeneratedDocumentTypeToJSON,
} from '../models/ScreenerGeneratedDocumentType';

export interface EnqueueGenerateReportRequest {
    /**
     * 
     */
    leadId: string;
    /**
     * 
     */
    reportType: ScreenerGeneratedDocumentType;
}

/**
 * 
 */
export class DefaultApi extends runtime.BaseAPI {

    /**
     * Creates request options for enqueueGenerateReport without sending the request
     */
    async enqueueGenerateReportRequestOpts(requestParameters: EnqueueGenerateReportRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['leadId'] == null) {
            throw new runtime.RequiredError(
                'leadId',
                'Required parameter "leadId" was null or undefined when calling enqueueGenerateReport().'
            );
        }

        if (requestParameters['reportType'] == null) {
            throw new runtime.RequiredError(
                'reportType',
                'Required parameter "reportType" was null or undefined when calling enqueueGenerateReport().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/leads/{lead_id}/generated-reports/{report_type}`;
        urlPath = urlPath.replace('{lead_id}', encodeURIComponent(String(requestParameters['leadId'])));
        urlPath = urlPath.replace('{report_type}', encodeURIComponent(String(requestParameters['reportType'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Only supports PCC-sourced report types (pcc_face_sheet_report, pcc_order_summary_report, pcc_md_history_report) — generation for every other type happens fast enough that the synchronous GET endpoint on crm-screener still applies. Returns immediately; poll ListGeneratedReports or GetGeneratedReportDownloadUrl for the result. 
     * Enqueue asynchronous generation of a PCC-sourced report
     */
    async enqueueGenerateReportRaw(requestParameters: EnqueueGenerateReportRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<EnqueueGenerateReport200Response>> {
        const requestOptions = await this.enqueueGenerateReportRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => EnqueueGenerateReport200ResponseFromJSON(jsonValue));
    }

    /**
     * Only supports PCC-sourced report types (pcc_face_sheet_report, pcc_order_summary_report, pcc_md_history_report) — generation for every other type happens fast enough that the synchronous GET endpoint on crm-screener still applies. Returns immediately; poll ListGeneratedReports or GetGeneratedReportDownloadUrl for the result. 
     * Enqueue asynchronous generation of a PCC-sourced report
     */
    async enqueueGenerateReport(requestParameters: EnqueueGenerateReportRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<EnqueueGenerateReport200Response> {
        const response = await this.enqueueGenerateReportRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
